const FX_SERVICE_MANAGER_CONSTANTS = {
  // FX Rates Config Actions
  GETTING_FX_RATES_CONFIG: 'GETTING_FX_RATES_CONFIG',
  GET_FX_RATES_CONFIG_SUCCESS: 'GET_FX_RATES_CONFIG_SUCCESS',
  GET_FX_RATES_CONFIG_FAILURE: 'GET_FX_RATES_CONFIG_FAILURE',
  UPDATING_FX_RATES_CONFIG: 'UPDATING_FX_RATES_CONFIG',
  UPDATE_FX_RATES_CONFIG_SUCCESS: 'UPDATE_FX_RATES_CONFIG_SUCCESS',
  UPDATE_FX_RATES_CONFIG_FAILURE: 'UPDATE_FX_RATES_CONFIG_FAILURE',
  RESET_FX_RATES_CONFIG_DATA: 'RESET_FX_RATES_CONFIG_DATA',

  // Vance FX Rates Actions
  GETTING_VANCE_FX_RATES: 'GETTING_VANCE_FX_RATES',
  GET_VANCE_FX_RATES_SUCCESS: 'GET_VANCE_FX_RATES_SUCCESS',
  GET_VANCE_FX_RATES_FAILURE: 'GET_VANCE_FX_RATES_FAILURE'
};

export default FX_SERVICE_MANAGER_CONSTANTS;
